import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import Effects from "%/dynamic-components/render-engine/options/effects";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import AnimationDuration from "%/dynamic-components/render-engine/options/animation-options/animation-duration";
import AnimationDelay from "%/dynamic-components/render-engine/options/animation-options/animation-delay";
import AnimationTimingFunction
  from "%/dynamic-components/render-engine/options/animation-options/animation-timing-function";
import AnimationIteration from "%/dynamic-components/render-engine/options/animation-options/animation-iteration";
import AnimationDirection from "%/dynamic-components/render-engine/options/animation-options/animation-direction";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";

export default class AnimationOptions extends BaseOptionsBundle {

  optionTitle = "Animations";
  static optionClassName = "i-dynamic-animations";
  inspectorToolGroup = "animations";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.ANIMATIONS_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Effects(undefined, hideFromInspector["effects"] ?? false),
      AnimationDuration,
      AnimationDelay,
      AnimationTimingFunction,
      AnimationIteration,
      AnimationDirection,
    ]);
  }
}
